import type { HashicorpCloudResourcemanagerRole } from '@clients/cloud-resource-manager';
import type { IamParsedRole } from '../types/iam-parsed-role.ts';

export const BASIC_ROLE_KEY_UI_ONLY = 'basic';

export function parseRoleId(
  roleId: HashicorpCloudResourcemanagerRole['id'] = '',
): IamParsedRole {
  const [, scopeAction = ''] = roleId.split('/');
  const [scope, action] = scopeAction.split('.');
  return { roleId, scope: action ? scope : BASIC_ROLE_KEY_UI_ONLY, action };
}

export default parseRoleId;
